const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    description: '所有软件经过多重安全检测，确保无病毒、无捆绑、无广告插件，让您下载无忧。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    description: '汇集3200+款优质免费软件，涵盖办公、设计、开发、生活等八大核心分类。',
  },
  {
    icon: 'ri-rocket-line',
    title: '高速下载',
    description: '多节点CDN加速，支持多线程下载技术，大幅缩短下载等待时间。',
  },
  {
    icon: 'ri-refresh-line',
    title: '实时更新',
    description: '追踪软件最新版本动态，第一时间推送更新提醒，始终使用最新功能。',
  },
  {
    icon: 'ri-book-open-line',
    title: '详细教程',
    description: '每款软件配备详细图文安装使用教程，新手也能轻松上手操作。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '贴心服务',
    description: '7×24小时在线客服支持，快速响应您的每一个问题与反馈。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-4">
            为什么选择我们
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            六大核心优势，打造极致体验
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            91免费版以用户需求为核心，持续优化产品体验，让每一位用户都能轻松找到并使用心仪的软件工具。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-8 rounded-lg bg-white border border-background-200/70 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-300">
                <i className={`${feature.icon} text-xl`} />
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}